module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kp-folder-table-title"
  }, [_c('div', {
    staticClass: "kp-folder-name"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.$t('general.labels.box_name')))])]), _vm._v(" "), _c('div', {
    staticClass: "kp-folder-testab"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.$t('index.list_header.modality')))])]), _vm._v(" "), _c('div', {
    staticClass: "kp-folder-updatedate"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.$t('index.list_header.last_modification')))]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-sort-desc"
  })]), _vm._v(" "), _c('div', {
    staticClass: "kp-folder-status"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.$t('general.labels.status')))])]), _vm._v(" "), _c('div', {
    staticClass: "kp-folder-actions"
  }, [_vm._v(_vm._s(_vm.$t('general.labels.actions')))])])
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-856ac430!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/index/list/ListHeader.vue
 ** module id = 883
 ** module chunks = 1
 **/